<script setup lang="ts">
import UIPane from '@/components/ui/UIPane'
import { focusFirstChild, setFocusTrap } from '@/composables/useFocusTrap'
import { onMounted, ref } from 'vue'

const emit = defineEmits<{ (e: 'close'): void }>()

const fullScreenModal = ref<HTMLDivElement | undefined>()

// Trap focus for a11y
const handleKeydown = (e) => {
  if (e.key == 'Escape') {
    emit('close')
  } else if (setFocusTrap(e, [fullScreenModal.value])) {
    // focus trap handled the event
  }
}

onMounted(() => {
  focusFirstChild(fullScreenModal.value)
})
</script>

<template>
  <div ref="fullScreenModal" v-global-keydown="handleKeydown">
    <div
      class="z-50 fixed inset-0 bg-black opacity-20"
      @click="$emit('close')"
    ></div>
    <UIPane
      class="z-51 fixed inset-0 sm:inset-[10px] lg:inset-5 flex flex-col"
      rounding="rounded-none sm:rounded"
    >
      <slot></slot>
    </UIPane>
  </div>
</template>
